import React from "react";
import "./Redeem.css";
import Coins from "../../assets/panelImages/redeem/earn points.svg";
import { IoIosStar } from "react-icons/io";

const giftCards = [
  {
    name: "Amazon",
    img: require("../../assets/panelImages/giftcard/Amazon.png"),
    values: [25000, 50000, 75000],
  },
  {
    name: "iTunes",
    img: require("../../assets/panelImages/giftcard/iTunes.png"),
    values: [25000, 50000, 75000],
  },
  {
    name: "Starbucks",
    img: require("../../assets/panelImages/giftcard/Starbucks.png"),
    values: [25000, 50000, 75000],
  },
  {
    name: "Shoppers Stop",
    img: require("../../assets/panelImages/giftcard/ShoppersStop.png"),
    values: [25000, 50000, 75000],
  },
  {
    name: "Starbucks",
    img: require("../../assets/panelImages/giftcard/Starbucks.png"),
    values: [25000, 50000, 75000],
  },
  {
    name: "Shoppers Stop",
    img: require("../../assets/panelImages/giftcard/ShoppersStop.png"),
    values: [25000, 50000, 75000],
  },
];

const RedeemOptions = () => {
  return (
    <div className="giftcard-container">
      <div className="balance-box">
        <h2>Available Balance</h2>
        <div className="points">
          <img src={Coins} alt="Points Icon" height={26}/>
          3,000 pts
        </div>
      </div>
    <hr className="redeem-hr" />
      <div className="cards-wrapper">
        {giftCards.map((card, index) => (
          <div className="giftcard-card" key={index}>
            <img src={card.img} alt={`${card.name} gift card`} />
            <div className="giftcard-values">
              {card.values.map((value, idx) => (
                <span className="value disabled" key={idx}>
                  <IoIosStar /> {value}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RedeemOptions;
